<div class="row">
  <app-card [hidHeader]="false" cardTitle="Cadastro de Usuário" [options]="false" class="col-sm-12" id="inicioPagina">
    <div class="row">
      <div class="col-sm-6 col-xl-6">
        <label class="sub-title">Nome</label>
        <input type="text" class="form-control" [(ngModel)]="user.nome" name="nome" placeholder="Digite o nome">
      </div>
      <div class="col-sm-6 col-xl-3">
        <label class="sub-title">Login</label>
        <input type="text" class="form-control" [(ngModel)]="user.login" name="login" placeholder="Digite o login">
      </div>
      <div class="col-sm-6 col-xl-3">
        <label class="sub-title">Senha</label>
        <input type="password" class="form-control" [(ngModel)]="user.senha" name="senha" placeholder="Digite a senha">
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-sm-6 col-xl-3">
        <label class="sub-title">Empresa</label>
        <select class="form-control" [(ngModel)]="user.id_empresa" name="id_empresa">
          <option value="">Selecione uma empresa</option>
          <option *ngFor="let company of companies" [value]="company.id">{{ company.nome }}</option>
        </select>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-sm-12">
        <button type="button" class="btn btn-warning float-left" (click)="goBack()">
          <i class="feather icon-arrow-left mr-2 f-18"></i>
          Voltar
        </button>
        <button type="button" class="btn btn-primary float-right" (click)="saveUser()">
          <i class="feather icon-check-circle mr-2 f-18"></i>
          {{ isEditing ? 'Atualizar' : 'Salvar' }}
        </button>
      </div>
    </div>
  </app-card>
</div>

<div class="row mt-4">
  <app-card [hidHeader]="false" cardTitle="Lista de Usuários" [options]="false" class="col-sm-12">
    <div class="table-responsive">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Nome</th>
            <th>Login</th>
            <th>Empresa</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of users">
            <td>{{ user.nome }}</td>
            <td>{{ user.login }}</td>
            <td>{{ getCompanyName(user.id_empresa) }}</td>
            <td>
              <button class="btn btn-sm btn-info mr-2" (click)="editUser(user)">
                <i class="feather icon-edit"></i>
              </button>
              <button class="btn btn-sm btn-danger" (click)="deleteUser(user.guid_usuario)">
                <i class="feather icon-trash-2"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </app-card>
</div>
